function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "WishMaker-Splacanie-uverov-2_0_0",
  transform: "translate(-1120.000000, -934.000000)",
  stroke: "#2F2E41",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(111.000000, 916.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Avtar",
  transform: "translate(1009.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,1 C15.0375661,1 17.7875661,2.23121694 19.7781746,4.22182541 C21.7687831,6.21243388 23,8.96243388 23,12 C23,15.0375661 21.7687831,17.7875661 19.7781746,19.7781746 C17.7875661,21.7687831 15.0375661,23 12,23 C8.96243388,23 6.21243388,21.7687831 4.22182541,19.7781746 C2.23121694,17.7875661 1,15.0375661 1,12 C1,8.96243388 2.23121694,6.21243388 4.22182541,4.22182541 C6.21243388,2.23121694 8.96243388,1 12,1 Z",
  id: "Rectangle"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-28",
  transform: "translate(6.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 5.9998714,
  cy: 3,
  r: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.99990151,8 C7.22343747,8 8.34642235,8.43661305 9.22678948,9.16403943 C9.9713418,9.77924528 10.5429669,10.6018497 10.856398,11.5451546 C9.4578666,12.4655207 7.79037197,13 5.99990151,13 C4.20934594,13 2.54177916,12.4654745 1.14329825,11.5452202 C1.45701703,10.6019696 2.0285427,9.77936303 2.77298559,9.16415413 C3.65333453,8.43663223 4.77634091,8 5.99990151,8 Z",
  id: "Path"
}))))));

var SvgReactionAvatar = function SvgReactionAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReactionAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reaction-avatar.5d0f657a.svg";
export { ForwardRef as ReactComponent };